import React, { useEffect } from "react";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import { transactionAddEdit } from "../../../../services/transactionService";
import DatePicker from "../../../form/DatePicker";
import Textarea from "../../../form/Textarea";
import useFetch from "../../../../hooks/useFetch";
import { paymentMethodList } from "../../../../services/PaymentService";

let validation = {
  firstName: { required: true, message: "firstname is required" },
  lastName: { required: true, message: "lastname is required" },
  email: { required: true, message: "email is required" },
  amount: { required: true, message: "amount is required" },
  date: { required: true, message: "date is required" },
  paymentMethod: { required: true, message: "payment method is required" },
  donationType: { required: true, message: "donation type is required" },
  donationFrequency: {
    required: true,
    message: "donation frequency is required",
  },
  paymentStatus: {
    required: true,
    message: "payment status is required",
  },
};

const ManageDonation = ({
  getResponse = () => {},
  close = () => {},
  details,
}) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({ validationRules: validation });

  validation.organizationName = {
    required: values?.donationType === "organization" ? true : false,
    message: "organizatio name is required",
  };
  useEffect(() => {
    if (details?._id) {
      setFieldsValue({
        ...details,
        pdf: details?.pdf?.url,
        recurringDate: details?.subscription?.recurringDate,
      });
    }
  }, [details]);

  const { data } = useFetch({
    dependencies: ["paymentMethod"],
    fetchFunction: async () => {
      const res = await paymentMethodList({
        limit: 10000,
      });
      return res?.docs;
    },
  });
  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      delete val?.name;
      return await transactionAddEdit({
        firstName: val?.firstName || "",
        lastName: val?.lastName || "",
        email: val?.email || "",
        amount: val?.amount || "",
        date: val?.date || "",
        paymentMethod: val?.paymentMethod || "",
        donationType: val?.donationType || "",
        donationFrequency: val?.donationFrequency || "",
        paymentStatus: val?.paymentStatus || "",
        recurringDate: val?.recurringDate || "",
        categoryType: "donation",
        ...(details?._id && { id: details?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="relative col-span-6">
          <Input
            label="Donor Firstname"
            inputPlaceholder={"Enter Donor Firstname"}
            inputName="firstName"
            value={values?.firstName || ""}
            onChange={handleChange}
            {...formValidate(errors, "firstName")}
          />
        </div>
        <div className="relative col-span-6">
          <Input
            label="Donor Lastname"
            inputPlaceholder={"Enter Donor Lastname"}
            inputName="lastName"
            value={values?.lastName || ""}
            onChange={handleChange}
            {...formValidate(errors, "lastName")}
          />
        </div>
        <div className="relative col-span-12">
          <Input
            label="Donor Email"
            inputPlaceholder={"Enter Donor Email"}
            inputName="email"
            value={values?.email || ""}
            onChange={handleChange}
            {...formValidate(errors, "email")}
          />
        </div>
        <div className="relative col-span-4">
          <Input
            label="Donation Amount"
            inputPlaceholder={"Enter Donation Amount"}
            inputName="amount"
            inputType={"number"}
            value={values?.amount || ""}
            onChange={handleChange}
            {...formValidate(errors, "amount")}
          />
        </div>
        <div className="relative col-span-4">
          <DatePicker
            label={"Date"}
            placeholder={"Select date"}
            value={{
              startDate: values?.date,
              endDate: values?.date,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "date" },
              });
            }}
            {...formValidate(errors, "date")}
          />
        </div>
        <div className="relative col-span-4">
          <Select
            label="Payment Method"
            placeholder="Select Payment Method"
            selectedValue={values?.paymentMethod}
            const
            dropdownData={
              data?.data?.map((item) => ({
                name: item?.name,
                value: item?.slug,
              })) || []
            }
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "paymentMethod", value: val },
              });
            }}
            {...formValidate(errors, "paymentMethod")}
          />
        </div>
        <div className="relative col-span-4">
          <Select
            label="Donation Type"
            placeholder="Select Donation Type"
            selectedValue={values?.donationType}
            dropdownData={
              [
                { name: "An Individual", value: "individual" },
                { name: "An Organization", value: "organization" },
              ] || []
            }
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "donationType", value: val },
              });
            }}
            {...formValidate(errors, "donationType")}
          />
        </div>
        {values?.donationType === "organization" && (
          <div className="relative col-span-8">
            <Input
              label="Organization Name"
              inputPlaceholder={"Enter Organization Name"}
              inputName="organizationName"
              value={values?.organizationName}
              onChange={handleChange}
              {...formValidate(errors, "organizationName")}
            />
          </div>
        )}
        <div className="relative col-span-4">
          <Select
            label="Donation Frequency"
            placeholder="Select Donation Frequency"
            selectedValue={values?.donationFrequency}
            dropdownData={
              [
                { name: "Monthly", value: "monthly" },
                { name: "One Time", value: "oneTime" },
              ] || []
            }
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "donationFrequency", value: val },
              });
            }}
            {...formValidate(errors, "donationFrequency")}
          />
        </div>
        <div className="relative col-span-4">
          <Select
            label={"Status"}
            placeholder="Select Status"
            selectedValue={values?.paymentStatus}
            dropdownData={[
              { name: "Success", value: "completed" },
              { name: "Pending", value: "pending" },
              { name: "Cancelled", value: "cancelled" },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "paymentStatus", value: val },
              });
            }}
            {...formValidate(errors, "paymentStatus")}
          />
        </div>
        {values?.donationFrequency === "monthly" && (
          <div className="relative col-span-4">
            <DatePicker
              label={"Recurring Date"}
              placeholder={"select recurring date"}
              value={{
                startDate: values?.recurringDate,
                endDate: values?.recurringDate,
              }}
              onChange={(e) => {
                handleChange({
                  target: { value: e?.startDate, name: "recurringDate" },
                });
              }}
            />
          </div>
        )}
        <div className="relative col-span-12">
          <Textarea
            label={"Message"}
            inputPlaceholder={"Enter Message"}
            inputName="purpose"
            inputValue={values?.purpose || ""}
            onChange={handleChange}
          />
        </div>

        {/* <FileUploadSingle
            size="small"
            accept="application/pdf"
            label={"PDF Attachment"}
            placeholder="Attach PDF"
            value={values?.pdf}
            onChange={(file) =>
              handleChange({ target: { name: "pdf", value: file } })
            }
            {...formValidate(errors, "pdf")}
          /> */}
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageDonation;
